import { Router } from '@angular/router';
import { Component, OnInit, HostListener } from '@angular/core';
import { PowerbiService } from '../../../services/powerbi.service';
import { ResponseEmbedconfigDto } from '../../../dto/powerbi/response.embedconfig.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { Constants } from '../../../constants/constants';
import { JustinoService } from '../../../services/justino.service';
import { ParameterDto } from '../../../dto/justino/parameter.dto';

@Component({
  selector: 'app-admin-mas',
  templateUrl: './admin-mas.component.html',
  styleUrl: './admin-mas.component.scss',
})
export class AdminMasComponent implements OnInit {
  // Define Variables
  embedUrl!: string;
  embedToken!: string;
  accessToken!: string;
  reportId!: string;
  groupId!: string;
  renderizarReporte = false;
  totalDatos!: string;
  descripcion!: string;
  isEditIntro = false;
  intro!: ParameterDto;

  // Define dinamic height
  height: string = '800px';

  // Define Zoom
  isZoomEnabled: boolean = true;

  // Define Mobile
  isMobile: boolean = true;

  // Define functions for admin
  functionAdm = [
    { name: 'Gestionar dominios', action: () => this.manageDomains() },
    { name: 'Gestionar base de conocimiento', action: () => this.manageKB() },
    { name: 'Gestionar roles', action: () => this.manageRols() },
    { name: 'Gestionar agentes', action: () => this.manageAgents() },
    {
      name: 'Actualizar videos configuración Justino',
      action: () => this.videosManagement(),
    },
    {
      name: 'Gestionar Funcionalidades',
      action: () => this.functionalitiesManagement(),
    },
    {
      name: 'Actualizar y gestionar información',
      action: () => this.informationManagement(),
    },
    { name: 'Gestionar Introducción', action: () => this.editIntro() },
    { name: 'Actualizar KB de funcionalidades', action: () => this.updateFunDB() },
    { name: 'Actualizar KB de normas', action: () => this.updateNormDB() },
  ];

  formEditIntro: FormGroup;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private pbiService: PowerbiService,
    private justinoService: JustinoService,
    private alertService: AlertaModalService
  ) {
    this.formEditIntro = this.formBuilder.group({
      description: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    if (infoInicioSesion.Nombre === 'Superadministrador') {
      console.log('Superadministrador');
    } else if (infoInicioSesion.Nombre === 'Administrador Funcional') {
      console.log('Administrador Funcional');
    } else {
      this.router.navigateByUrl('/');
    }
    this.pbiService
      .getReporte('justino')
      .subscribe((data: ResponseEmbedconfigDto) => {
        this.embedUrl = data.reportDetails.embedUrl;
        this.embedToken = data.embedToken.token;
        this.accessToken = data.accessToken;
        this.reportId = data.reportDetails.id;
        this.groupId = data.reportDetails.workspaceId;
        this.renderizarReporte = true;
      });
  }

  async manageAgents() {
    const url = '/justino/agentes';
    await this.router.navigateByUrl(url);
  }

  async manageDomains() {
    const url = '/justino/dominios/base';
    await this.router.navigateByUrl(url);
  }

  async manageRols() {
    const url = '/justino/roles';
    await this.router.navigateByUrl(url);
  }

  async manageKB() {
    const url = '/justino/bases-conocimiento';
    await this.router.navigateByUrl(url);
  }

  async manageReview() {
    const url = '/justino/preguntas';
    await this.router.navigateByUrl(url);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustHeight();
  }

  adjustHeight(): void {
    if (this.isMobile) {
      this.height = '800px';
      return;
    }
    const windowWidth = window.innerWidth;
    this.height = `${windowWidth * 0.3}px`;
  }

  async videosManagement() {
    const url = '/justino/gestion-videos';
    await this.router.navigateByUrl(url);
  }

  async functionalitiesManagement() {
    const url = '/justino/gestion-funcionalidades';
    await this.router.navigateByUrl(url);
  }

  async informationManagement() {
    const url = '/justino/gestion-documentos/1';
    await this.router.navigateByUrl(url);
  }

  async editIntro() {
    this.justinoService.getParameterByName(Constants.INTRO_PARAM).subscribe({
      next: data => {
        this.intro = data;
        this.formEditIntro.patchValue({
          description: data.Value,
        });
        this.isEditIntro = true;
      },
      error: err => {
        console.error('Error loading parameter:', err);
        this.alertService.error(
          'Error',
          `No se pudo cargar el parámetro ${Constants.INTRO_PARAM}. Por favor, inténtelo de nuevo más tarde.`
        );
      },
    });
  }

  async updateFunDB() {
    this.justinoService.updateFunKB().subscribe({
      next: data => {
        if (data['status'] === 'success') {
          this.alertService.exito(
            'La solicitud de actualización de la base de conocimiento de funcionalidades se ha enviado correctamente.'
          );
        } else {
          this.alertService.error(
            'Error',
            'No se pudo actualizar la base de conocimiento de funcionalidades. Por favor, inténtelo de nuevo más tarde.'
          );
        }
      },
      error: err => {
        console.error('Error loading parameter:', err);
        this.alertService.error(
          'Error',
          'No se pudo enviar la solicitud de actualización de la base de conocimiento de funcionalidades. Por favor, inténtelo de nuevo más tarde.'
        );
      },
    });
  }

  async updateNormDB() {
    this.justinoService.updateLaKB().subscribe({
      next: data => {
        if (data['status'] === 'success') {
          this.alertService.exito(
            'La solicitud de actualización de la base de conocimiento de normas se ha enviado correctamente.'
          );
        } else {
          this.alertService.error(
            'Error',
            'No se pudo actualizar la base de conocimiento de normas. Por favor, inténtelo de nuevo más tarde.'
          );
        }
      },
      error: err => {
        console.error('Error loading parameter:', err);
        this.alertService.error(
          'Error',
          'No se pudo enviar la solicitud de actualización de la base de conocimiento de normas. Por favor, inténtelo de nuevo más tarde.'
        );
      },
    });
  }

  onSubmit() {
    if (this.formEditIntro.valid) {
      const description = this.formEditIntro.get('description')?.value;
      this.intro.Value = description;
      this.justinoService.updateParameter(this.intro).subscribe({
        next: () => {
          this.alertService.exito(
            'La introducción se ha actualizado correctamente'
          );
          this.isEditIntro = false;
          this.formEditIntro.reset();
        },
        error: () => {
          this.alertService.error(
            'Error',
            `No se pudo actualizar el parámetro ${Constants.INTRO_PARAM}. Por favor, inténtelo de nuevo más tarde.`
          );
        },
      });
    } else {
      this.alertService.error('La introducción es obligatoria');
    }
  }
}
